import React, {Fragment, useEffect, useRef, useState} from 'react';
import {useDispatch} from 'react-redux';

//helpers
import {
    formatDateFromFilter,
    formatDatetime,
    formatGeneralNumber,
    getEntityType,
    getGroupId,
    getMethodToFormatDuration,
    getNameUnitDriverTag,
    useHandleExportReport
} from 'Modules/reports/views/main/components/reportsTab/helper';

//actions
import {reportsMainGenerateReportUpdate} from 'Redux/actions';

import './landmarkReport.scss'
import {useReportsSelector, useSidePanelMap} from "Core/hooks";
import {GetFormatForMoment} from "Core/data/Helpers";
import {isKPHAcronym, convertUnitValue} from '../../../helper';
import {Grid} from "@mui/material";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import {getAbbvTimezone} from "Components/uiControls/Timezone/tools";
import InfiniteScrollTable from "Modules/reports/views/main/components/reportsTab/.components/infiniteScrollTable";

const ROW_PER_PAGE = 25;
const LandmarkReport = (props) => {
    const {messages, report, user, copyReportToSetup, openReportSetup, scheduleReport, isActive} = props;
    const { durationFormat } = user;
    const dispatch = useDispatch()
    const {loading, asyncLoading, data, filters, timeZone} = report
    const {filterEntity, filterArray, filterType} = filters;
    const exportHandler = useHandleExportReport(report)
    const [SideMapComponent, onToggleSideMap] = useSidePanelMap();
    const [lastEntity, setLastEntity] = useState({});
    const [showSummary, setShowSummary] = useState({});
    const momentFormat = GetFormatForMoment(user.dateformat)

    const startDayFilter = formatDateFromFilter(report.filters.startRange, timeZone)
    const endDayFilter = formatDateFromFilter(report.filters.endRange, timeZone)

    const reportRef = useRef();
    const entitiesArrayRef = useRef();
    const detailReportTableRef = useRef();
    const lastEntityRef = useRef({});
    const reportTableSelect = useReportsSelector(report, startDayFilter, endDayFilter, `MMMM DD, YYYY hh:mm A`, filterArray, filterType, timeZone)
    const unitDriverSelected = reportTableSelect.valueSelecteEntity?.length > 0 ? reportTableSelect.valueSelecteEntity : null;
    const dateSelected = reportTableSelect.dateSelected?.length > 0 ? reportTableSelect.dateSelected : null;
    useEffect(() => {
        if (report) {
            const newReport = JSON.parse(JSON.stringify(report));
            reportRef.current = newReport;
        }
    }, [JSON.stringify(report)]);

    useEffect(() => {
        if (isActive) {
            reportTableSelect.onChangeResetCache();
        }
    }, [isActive])

    const durationFormatTime = getMethodToFormatDuration(durationFormat);
    const buildTableTotalHeader = () => {
        return (
            <Grid container item direction={"row"} className={"table-scroll-reports-title-details"}>
                <Grid item sm={3} className={'reports-cut-text'}>
                    {messages['generatedReport_landmarkLabel']}
                </Grid>
                <Grid item sm={5} className={'reports-cut-text'}>
                    {`${messages['generatedReport_total']} ${messages['generatedReport_distanceInLandmark']}`}
                </Grid>
                <Grid item sm={4} className={'reports-cut-text'}>
                    {`${messages['generatedReport_total']} ${messages['generatedReport_timeInLandmarkAll']}${durationFormat === 'hh' ? ` (${messages['generatedReport_hour']})` : ''}`}
                </Grid>
            </Grid>
        )
    }

    const buildTableHeader = () => {
        return (
            <Grid container item direction={"row"} className={"table-scroll-reports-title-details"}>
                <Grid item sm={3} className={'reports-cut-text'}>
                    {messages['generatedReport_landmarkLabel']}
                </Grid>
                <Grid item sm={2.2} className={'reports-cut-text'}>
                    {messages['generatedReport_enterLandmark'] + ' ' + messages['generatedReport_landmarkLabel']}
                </Grid>
                <Grid item sm={2.2} className={'reports-cut-text'}>
                    {messages['generatedReport_leaveLandmark'] + ' ' + messages['generatedReport_landmarkLabel']}
                </Grid>
                <Grid item sm={2.3} className={'reports-cut-text'}>
                    {messages['generatedReport_distanceInLandmark']}
                </Grid>
                <Grid item sm={2.3} className={'reports-cut-text'}>
                    {messages['generatedReport_timeInLandmarkAll'] + `${durationFormat === 'hh' ? ` (${messages['generatedReport_hour']})` : ''}`}
                </Grid>
            </Grid>
        )
    }

    const TableViewGroup = ({index, style, content, id, previousItem}) => {
        const element = content?.recordInfo;
        const recordInfo = content?.recordInfo;

        return (
            <div
                className="listItem groupItem"
                id={id}
                key={id}
                style={style}
            >

                <Grid container direction={"column"} alignItems={"flex-start"} className='table-scroll-reports-group' style={{marginTop: '15px'}}>
                    <Grid container item className='table-scroll-reports-header'>
                        <Grid item sm={3}>

                            {
                                element?.tagId > 0 ?
                                    (<LocalOfferIcon
                                        style={{fontSize: "16.8px", color: `#${element.groupTagColor && element.groupTagColor != "ffffff" ? element.groupTagColor : "000"}`, position: 'absolute'}}/>)
                                    : ""
                            }
                            <span className={`color-text-black ${element?.tagId > 0 ? 'report-home-header-padding':''}`}>{`${getNameUnitDriverTag(recordInfo?.groupLabel, messages)}`}</span>
                            {
                                report?.filters?.filterArray.length !== 1 && (<span  className={'color-text-black report-home-header-padding-text'}>{` (${element?.tagId > 0 ? `${getNameUnitDriverTag(filterEntity, messages)} ` : ''}${recordInfo?.groupIndex} ${messages['OF']} ${recordInfo?.groupTotal})`}</span>)
                            }
                        </Grid>
                        <Grid item sm={9}>
                            <span className={'color-text-black'}>{formatDatetime(report.filters.startRange, "MMMM D, YYYY h:mm A", timeZone).toUpperCase()} - {formatDatetime(report.filters.endRange, "MMMM D, YYYY h:mm A", timeZone).toUpperCase()} ({getAbbvTimezone(timeZone)})</span>
                        </Grid>
                    </Grid>
                    <div className='table-scroll-reports-separator'></div>
                    <Grid item>
                        <p className='table-scroll-reports-label'>{element?.entityLabel}</p>
                    </Grid>
                </Grid>
                {showSummary?.recordDetail ? buildTableHeader() : buildTableTotalHeader()}
            </div>
        )
    }

    const TableViewSummary = ({index, style, content, id, previousItem}) => {
        const item = content?.recordDetail;

        return (
            <div
                className="listItem"
                id={id}
                key={id}
                style={style}
            >

                <Grid container direction={"column"} style={{marginBottom: "1px"}}>
                    <Grid container item direction={"row"} style={{paddingTop: "1px", paddingBottom: "1px"}}>
                        <Grid item className={"report-ctn-text"} sm={3} style={{paddingLeft: "15px"}}>
                            {item.landmarkName}
                        </Grid>
                        <Grid item className={"report-ctn-text"} sm={5}>
                          <span>
                            {`${item.totalDistance ? formatGeneralNumber(convertUnitValue(item.totalDistance, item.isKPH, user.isKph)) : '0.00'} ${messages[isKPHAcronym(user.isKph)]}`}
                          </span>
                        </Grid>
                        <Grid item className={"report-ctn-text"} sm={4} style={{ paddingLeft: "15px" }}>
                          <span>
                            {`${item.totalDuration > 0 ? durationFormatTime(item.totalDuration, messages) || '0 min, 0 sec' : '0 min, 0 sec'}`}
                          </span>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        )
    }

    const TableViewDetail = ({index, style, content, id, previousItem}) => {
        const element = content?.recordDetail;
        const recordInfo = content?.recordInfo;
        const preRecordInfo = previousItem?.recordInfo;
        return (
            <div
                className="listItem detailItem"
                style={style}
                id={id}
                key={id}
            >
                {recordInfo.recordType !== preRecordInfo.recordType && buildTableHeader()}
                <Grid container direction={"column"} style={{marginBottom: "10px"}}>
                    <Grid container item direction={"row"} className={'report-landmark-size-cell'}>
                        {
                            element.noData ?
                                <Grid item className={"report-ctn-text"} sm={12}>
                                    {messages["reportsMainRT_noDataEvent"]}
                                </Grid>
                                :
                                <>
                                    <Grid item className={"report-ctn-text"} sm={3} style={{paddingLeft: "15px"}}>
                                        {element.landmarkName}
                                    </Grid>
                                    <Grid item className={"report-ctn-text"} sm={2.2}>
                                        {element.enterLandmarkTime && formatDatetime(element.enterLandmarkTime, `h:mm A ${momentFormat || "MMMM D, YYYY"}`, timeZone)}
                                    </Grid>
                                    <Grid item className={"report-ctn-text"} sm={2.2}>
                                        {element.departLandmarkTime === '--' ? element.departLandmarkTime : formatDatetime(element.departLandmarkTime, `h:mm A ${momentFormat || "MMMM D, YYYY"}`, timeZone)}
                                    </Grid>
                                    <Grid item className={"report-ctn-text"} sm={2.3}>
                                      <span>
                                        {`${element.distance ? formatGeneralNumber(convertUnitValue(element.distance, element.isKPH, user.isKph)) : '0.00'} ${messages[isKPHAcronym(user.isKph)]}`}
                                      </span>
                                    </Grid>
                                    <Grid item className={"report-ctn-text"} sm={2.3}>
                                      <span>
                                        {`${durationFormatTime(element.duration > 0 ? element.duration : 0, messages)}`}
                                      </span>
                                    </Grid>
                                </>
                        }
                    </Grid>
                    <Grid container item direction={"row"} className={"report-landmark-subtable"}>
                        <Grid item className={"report-ctn-text"} sm={3}>
                            {`${messages['generatedReport_betweenLandMark']}`}
                        </Grid>
                        <Grid item className={"report-ctn-text"} sm={2.2}>
                        </Grid>
                        <Grid item className={"report-ctn-text"} sm={2.2}>
                        </Grid>
                        <Grid item className={"font-size-subtable-landmark"} sm={2.3} style={{ paddingLeft: "8px" }}>
                          <span>
                            {`${element.distanceBetweenLandmark ? formatGeneralNumber(convertUnitValue(element.distanceBetweenLandmark, element.isKPH, user.isKph)) : '0.00'} ${messages[isKPHAcronym(user.isKph)]}`}
                          </span>
                        </Grid>
                        <Grid item className={"font-size-subtable-landmark"} sm={2.3} style={{ paddingLeft: "15px" }}>
                          <span>
                            {`${durationFormatTime(element.durationBetweenLandmark > 0 ? element.durationBetweenLandmark : 0, messages)}`}
                          </span>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        )
    }

    const renderItems = (parameters) => {
        const {content} = parameters;
        const type = content.recordInfo?.recordType;
        if (type === "GROUP") {
            const groupId = getGroupId(content)
            const entitiesArray = entitiesArrayRef.current || {};
            if (!entitiesArray[groupId]) {
                const newEntityArray = {...entitiesArray};
                newEntityArray[groupId] = content;
                entitiesArrayRef.current = newEntityArray
            }
            // skip the first group beacuse the first group is replaced with the sticky header
            if (parameters.index === 0) {
                return;
            }

            return (
                <TableViewGroup {...parameters}></TableViewGroup>
            )
        } else if (type === "UNIT_SUMMARY") {
            return <TableViewSummary {...parameters}></TableViewSummary>;
        } else if (type === "DETAIL") {
            return <TableViewDetail {...parameters}></TableViewDetail>;
        }

        if (parameters.index === 0) {
            return;
        }

        return (
            <div>
                unknown type
            </div>
        )
    }

    const onStartIndex = (index) => {
        const item = data?.items[index];
        if (item?.recordInfo.recordType === 'DETAIL') {
            setShowSummary(item);
        } else {
            setShowSummary({})
        }
        if (item) {
            if (item.recordInfo?.entityId !== lastEntityRef.current.recordInfo?.entityId || item.recordInfo?.tagId !== lastEntityRef.current.recordInfo?.tagId) {
                setLastEntity(item)
            }
            lastEntityRef.current = item
        }
    }

    const renderHeader = () => {
        const groupId = getGroupId(lastEntity);
        const entitiesArray = entitiesArrayRef.current || {};
        const itemHeader = entitiesArray[groupId];

        if (itemHeader) {
            return (
                <TableViewGroup
                    style={{
                        backgroundColor: '#fff',
                        position: 'sticky',
                        top: 0,
                        zIndex: 2

                    }}
                    content={itemHeader}
                    id={itemHeader?.recordInfo?.entityId}
                ></TableViewGroup>
            );
        }
        return;

    };

    const type = getEntityType(report, messages);
    return (
        <>
            <InfiniteScrollTable
                refContainer={detailReportTableRef}
                renderItems={renderItems}
                loading={asyncLoading || loading}
                data={data.items || []}
                total={data.total}
                reportTitle={messages['reportsMainRT_landmarkReport']}
                editReport={() => {
                    copyReportToSetup({...report, data: []})
                }}
                onSchedule={() => {
                    scheduleReport(report)
                }}
                onCreate={openReportSetup}
                tableContainerClass={"landmark-report-reports-container"}
                type={type}
                handleNewPageLoad={(page) => {
                    let currentReport = {...report};
                    currentReport.exportType = "json";
                    currentReport.filters = {
                        ...currentReport.filters,
                        unitsSelected: unitDriverSelected?.id != -99 ? unitDriverSelected : null,
                        accumulateData: true,
                        dateSelected: dateSelected?.id != -99 ? unitDriverSelected : null,
                    };
                    dispatch(reportsMainGenerateReportUpdate(currentReport, page, ROW_PER_PAGE))
                }}
                renderHeader={renderHeader}
                onStartIndex={onStartIndex}
                isActive={isActive}
                {...reportTableSelect}
                {...exportHandler}
            />
            <SideMapComponent hiddenButton hiddenSearchMap overlayClass={"overlay-class-reports"}/>
        </>
    );
};
export default LandmarkReport;
